import { useUserProfile } from "@src/components/user/user-context";

export function AuthenticatedComponentGuard({
	children,
	loadingComponent = null,
}: {
	children: React.ReactNode;
	loadingComponent?: React.ReactNode;
}) {
	const { user: userState } = useUserProfile();
	const [user] = userState;

	if (!user) {
		return loadingComponent;
	}

	return user ? children : null;
}
